import { render, staticRenderFns } from "./show-versions.vue?vue&type=template&id=622fc6ad&scoped=true&"
import script from "./show-versions.vue?vue&type=script&lang=js&"
export * from "./show-versions.vue?vue&type=script&lang=js&"
import style0 from "./show-versions.vue?vue&type=style&index=0&id=622fc6ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622fc6ad",
  null
  
)

export default component.exports